import router from "./router";
import i18n from "./i18n";

export const profileModuleRouter = router;
export const profileModuleI18n = i18n;
